module.exports = __webpack_public_path__ + "media/src/public/fonts/Gals-Bold-3cdb5445151c96f72fea13e7fa56146e.woff";